export const DOWNLOAD_CSV_DATE_RANGE_LIMIT = 1;
export const INSIGHTS_DATE_RANGE_LIMIT = 12;
